import Vue from 'vue';
import VueRouter from 'vue-router';
import util from '@/util';
import { device } from 'lib';
import {
  // handleUrl,
  // checkIdValid,
  handlerGlobalClass,
  identityVerification,
} from './guards';

const list = () => import('@/pages/list/list');
const detail = () => import('@/pages/detail/detail');
const filePreview = () => import('@/pages/file-preview/file-preview');
const KnowledgeListPage = () => import('@knowledge-list-page/index');
const error = () => import('@/pages/error/error');
const Ai = () => import('@/pages/ai/ai');

const scrmList = () => import('@/pages/scrm/list/list');
const scrmDetail = () => import('@/pages/scrm/detail/detail');

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    // redirect: '/detail',
    component: detail,
    beforeEnter: (to, from, next) => {
      const fromUrlParams = util.getUrlParams();
      let nextParams = undefined;
      // 没带链接的走列表页
      if (!fromUrlParams.id) {
        nextParams = {
          path: '/list',
        };
      }
      next(nextParams);
    },
  },
  {
    path: '/error',
    name: 'error',
    component: error,
    props: true,
    meta: { notUser: true },
  },
  {
    path: '/list',
    component: list,
    meta: { keepAlive: true },
    beforeEnter: (to, from, next) => {
      let nextParams = undefined;
      if (!device.isMobile && window.isPublic) {
        nextParams = {
          path: '/web-list',
        };
      }
      next(nextParams);
    },
  },
  {
    path: '/web-list',
    name: 'web-list',
    component: KnowledgeListPage,
    meta: { keepAlive: true },
  },
  {
    path: '/detail',
    component: detail,
  },
  {
    path: '/ai',
    component: Ai,
  },
  {
    path: '/file-preview',
    component: filePreview,
    meta: { notUser: true },
  },
  {
    path: '/scrm/list',
    component: scrmList,
    meta: { keepAlive: true, notUser: true },
  },
  {
    path: '/scrm/detail',
    component: scrmDetail,
    meta: { notUser: true },
  },
  // {
  //   path: '*',
  //   redirect: '/error',
  // },
];

const router = new VueRouter({
  routes,
});

// // 处理url
// router.beforeEach(handleUrl);
// // 校验值
// router.beforeEach(checkIdValid);
// 全局链接
// router.beforeEach(identityVerification);
// 全局链接
router.beforeEach(handlerGlobalClass);

export default router;
